import React, { useState } from 'react';
import { Phone, Mail, Send } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };
  return <section id="contact" className="py-20 md:py-24 bg-brand-900 text-white relative overflow-hidden" data-id="element-52" data-mp="3sx8153x0bxgd">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53" data-mp="3oy8u9drptqma">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-54" data-mp="3k3uwx5tht9ez">
          {/* Contact Info */}
          <div className="space-y-8" data-id="element-55" data-mp="3f59t6wf187ls">
            <div data-id="element-56" data-mp="3f48hcpq6zh30">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-57" data-mp="ggcjg2p77zup">
                Get a Free Case Evaluation
              </h2>
              <p className="text-brand-100 text-lg leading-relaxed" data-id="element-58" data-mp="bokx64d2sgad">
                Time is limited to file a claim in California. Contact the
                state's premier mesothelioma law firm today. We are available
                24/7 to discuss your case at no cost to you.
              </p>
            </div>

            <div className="space-y-6" data-id="element-59" data-mp="3b2rfc5yar305">
              <a href="tel:805-770-9317" className="flex items-center gap-4 group" data-id="element-60" data-mp="3f4mi7evvlog1">
                <div className="bg-brand-800 p-4 rounded-full group-hover:bg-brand-accent transition-colors" data-id="element-61" data-mp="3141woaykteiu">
                  <Phone className="w-6 h-6 text-white group-hover:text-brand-900 transition-colors" data-id="element-62" data-mp="364ze2lbri4ja" />
                </div>
                <div data-id="element-63" data-mp="2s6hvt34mlk8r">
                  <div className="text-sm text-brand-200 font-medium" data-id="element-64" data-mp="2w60h400czxc4">
                    Call Us 24/7
                  </div>
                  <div className="text-2xl font-bold text-white group-hover:text-brand-accent transition-colors" data-id="element-65" data-mp="qcseegfo5u71">
                    (805) 770-9317
                  </div>
                </div>
              </a>

              <div className="flex items-center gap-4" data-id="element-66" data-mp="23cn3gss9x5lc">
                <div className="bg-brand-800 p-4 rounded-full" data-id="element-67" data-mp="1ychbtcm07j39">
                  <Mail className="w-6 h-6 text-brand-accent" data-id="element-68" data-mp="1yb663790019i" />
                </div>
                <div data-id="element-69" data-mp="1ubp10exhh64v">
                  <div className="text-sm text-brand-200 font-medium" data-id="element-70" data-mp="1ud02u97dc3tc">
                    Email Us
                  </div>
                  <div className="text-lg font-bold text-white" data-id="element-71" data-mp="2m2244m41rsp7">
                    help@pacificcoastmesolaw.com
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl text-slate-900" data-id="element-72" data-mp="2d8q9i9q8xodk">
            {submitted ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 py-12" data-id="element-73" data-mp="289vmswp5rfo6">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4" data-id="element-74" data-mp="35rdn742wy14m">
                  <Send className="w-8 h-8" data-id="element-75" data-mp="30xhqs62asmbk" />
                </div>
                <h3 className="text-2xl font-bold text-brand-900" data-id="element-76" data-mp="38c1v6ukfla3n">
                  Request Received
                </h3>
                <p className="text-slate-600" data-id="element-77" data-mp="3dboaranqf2fm">
                  Thank you for reaching out. A legal specialist will contact
                  you shortly to discuss your case.
                </p>
                <button onClick={() => setSubmitted(false)} className="mt-4 text-brand-600 font-medium hover:text-brand-800" data-id="element-78" data-mp="3m85n2h7u16cy">
                  Submit another request
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-79" data-mp="4ua6bp1ld69o">
                <h3 className="text-2xl font-bold text-brand-900 mb-6" data-id="element-80" data-mp="9t4r2wj4d4wf">
                  Confidential Contact Form
                </h3>

                <div className="grid grid-cols-2 gap-4" data-id="element-81" data-mp="dw9qurbteshd">
                  <div className="space-y-2" data-id="element-82" data-mp="isrutozbmmsn">
                    <label htmlFor="firstName" className="text-sm font-medium text-slate-700" data-id="element-83" data-mp="irgpvlu538zy">
                      First Name *
                    </label>
                    <input required type="text" id="firstName" name="firstName" placeholder="Jane" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-84" data-mp="ewma65ab11vs" />
                  </div>
                  <div className="space-y-2" data-id="element-85" data-mp="3sctsvljk2t2y">
                    <label htmlFor="lastName" className="text-sm font-medium text-slate-700" data-id="element-86" data-mp="3nbwbhb6de32i">
                      Last Name *
                    </label>
                    <input required type="text" id="lastName" name="lastName" placeholder="Doe" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-87" data-mp="12l5a9xj7a8cs" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-88" data-mp="347kfdykha0rt">
                  <label htmlFor="phone" className="text-sm font-medium text-slate-700" data-id="element-89" data-mp="348m1cy3187ob">
                    Phone Number *
                  </label>
                  <input required type="tel" id="phone" name="phone" placeholder="(555) 123-4567" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-90" data-mp="2ufwted6oxbxq" />
                </div>

                <div className="space-y-2" data-id="element-91" data-mp="omyhhtmcbsq">
                  <label htmlFor="email" className="text-sm font-medium text-slate-700" data-id="element-92" data-mp="mtp3urmfdh1">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" placeholder="you@example.com" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" data-id="element-93" data-mp="3myh4dzt0hxxh" />
                </div>

                <div className="space-y-2" data-id="element-94" data-mp="2z6aenjhskp71">
                  <label htmlFor="message" className="text-sm font-medium text-slate-700" data-id="element-95" data-mp="2z58sojz8miaj">
                    Brief Description of Your Case
                  </label>
                  <textarea id="message" name="message" rows={4} placeholder="Tell us briefly about the diagnosis and exposure history…" autoComplete="off" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all resize-none" data-id="element-96" data-mp="1aoz2xgo0oi55"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-brand-accent hover:bg-brand-accentHover text-brand-900 font-bold text-lg py-4 rounded-md transition-all shadow-md hover:shadow-lg disabled:opacity-70 flex justify-center items-center gap-2" data-id="element-97" data-mp="vy9p06j68oxl">
                  {isSubmitting ? 'Sending...' : 'Request Free Consultation'}
                </button>

                <p className="text-xs text-slate-500 text-center mt-4" data-id="element-98" data-mp="32p2bcsvhn864">
                  Information submitted is strictly confidential and does not
                  create an attorney-client relationship.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}